/* ラジオボタン */
import React, { memo } from 'react';
import { Form } from 'react-bootstrap';
var InputRadioButton = function (_a) {
    var name = _a.name, class_name = _a.class_name, value_list = _a.value_list, handleChange = _a.handleChange, checkedValue = _a.checkedValue;
    return (React.createElement(React.Fragment, null, value_list === null || value_list === void 0 ? void 0 : value_list.map(function (item, index) {
        return (React.createElement("label", { className: "radio-label", key: index },
            React.createElement(Form.Check, { type: "radio", inline: true, value: item.value, name: name, checked: item.value === checkedValue, onChange: handleChange, disabled: false, className: class_name }),
            item.key));
    })));
};
export default memo(InputRadioButton);
